



import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate hook from react-router-dom
import BrandHeader from "./BrandHeader";
import Navbar from "./Navbar";
import '../../App.css';
const CampaignReports = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
    const [isSmallScreen, setIsSmallScreen] = useState(false);
  const navigate = useNavigate(); // Initialize useNavigate hookssssd

  useEffect(() => {
    // Retrieve brandId from localStorage
    const brandId = localStorage.getItem("brandID");

    if (brandId) {
      // Fetch campaigns from the API
      const fetchCampaigns = async () => {
        try {
          const response = await fetch(
            `https://server-side-influencer.onrender.com/brand/getMyCampaigns/${brandId}`, // Using brandId from localStorage
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          const data = await response.json();
          if (data.success) {
            setCampaigns(data.data); // Set the fetched campaigns
          }
        } catch (error) {
          console.error("Error fetching campaigns:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchCampaigns();
    } else {
      console.error("Brand ID not found in localStorage.");
      setLoading(false);
    }
  }, []); // Empty dependency array ensures this runs once when the component mounts

  // Handle campaign click to navigate programmatically
  const handleCampaignClick = (campaign) => {
    navigate('/veiwreports', {
      state: {
        campaignId: campaign._id,
        campaignName: campaign.campaignName,
        tags: campaign.tags,
      },
    });
  };

     useEffect(() => {
        const handleResize = () => {
   
          setIsSmallScreen(window.innerWidth <= 780);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);
  return (
    <div className="flex h-screen mb-0 justify-center items-center w-full page-scroll" >
      {/* Navbar with higher z-index */}
      <div className="text-white fixed top-0 left-0 bottom-0 z-50">
        <Navbar />
      </div>

      <div className="h-screen ml-0 w-full">
        {/* Brand Header */}
        <BrandHeader page="campaign reports" />

        {/* Main Content Section sssss*/}
        <main className="flex-1 bg-white-100 p-8"  style={{

  marginTop: isSmallScreen ? '80px' : '50px'
}} >
          <h2 className="text-5xl font-semibold text-center  text-base  sm:text-2xl ">
            Monitor Your Campaign Performance
          </h2>
          <p className="mt-4 text-2xl text-center text-[#616E7c] mb-5    text-base  sm:text-2xl">
            Track influencer performance in real-time, measure campaign success, and instantly monitor individual influencer results.
          </p>

          {/* Cards Section */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-12 justify-center ml-12">
            {/* Example Card - Track Link Clicks */}
            <div className="w-full max-w-lg bg-white border border-gray-200 rounded-lg shadow-sm">
              <a href="#">
                <img
                  className="rounded-t-lg w-full h-56 object-cover"
                  src="https://i.postimg.cc/W4TvRBvL/image.png"
                  alt="Track Link Clicks"
                />
              </a>
              <div className="p-5">
                <a href="#">
                  <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900">
                    Track Link Clicks
                  </h5>
                </a>
                <p className="mb-3 font-normal text-gray-700">
                  Generate unique tracking links for each influencer and analyze the traffic they drive.
                </p>
              </div>
            </div>

            {/* Example Card - Top Influencers & Posts */}
            <div className="w-full max-w-lg bg-white border border-gray-200 rounded-lg shadow-sm">
              <a href="#">
                <img
                  className="rounded-t-lg w-full h-56 object-cover"
                  src="https://i.postimg.cc/L8R9RYtb/image2.png"
                  alt="Top Influencers & Posts"
                />
              </a>
              <div className="p-5">
                <a href="#">
                  <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900">
                    Top Influencers & Posts
                  </h5>
                </a>
                <p className="mb-3 font-normal text-gray-700">
                  Identify top-performing influencers and posts for the campaign, with detailed insights and analysis.
                </p>
              </div>
            </div>

            {/* Example Card - Measure Campaign Success */}
            <div className="w-full max-w-lg bg-white border border-gray-200 rounded-lg shadow-sm">
              <a href="#">
                <img
                  className="rounded-t-lg w-full h-56 object-cover"
                  src="https://i.postimg.cc/HLN1JVMH/imag3.png"
                  alt="Measure Campaign Success"
                />
              </a>
              <div className="p-5">
                <a href="#">
                  <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900">
                    Measure Campaign Success
                  </h5>
                </a>
                <p className="mb-3 font-normal text-gray-700">
                  Analyze overall performance, track results by influencer types, and monitor daily engagement and reel views.
                </p>
              </div>
            </div>
          </div>

          {/* New Section Below Cards */}
          <div className="mt-12 flex flex-col sm:flex-row justify-center gap-8">
            {/* Left Side - Campaign List */}
            <div className="w-full sm:w-2/3 max-w-3xl bg-white border border-gray-200 rounded-lg shadow-sm p-6">
              <h3 className="text-3xl font-bold text-left">GET STARTED WITH CAMPAIGNS</h3>
              <ul className="list-disc pl-8 space-y-2 mt-4">
                {/* List items with programmatic navigation */}
                {loading ? (
                  <li>Loading campaigns...</li>
                ) : (
                  campaigns.map((campaign) => (
                    <li key={campaign._id}>
                      <button
                        onClick={() => handleCampaignClick(campaign)} // Programmatic navigation on click
                        className="text-xl font-semibold hover:text-blue-600"
                      >
                        {campaign.campaignName}
                      </button>
                    </li>
                  ))
                )}
              </ul>
            </div>

            {/* Right Side - Video Demo */}
            <div className="w-full sm:w-1/3 bg-white border border-gray-200 rounded-lg shadow-sm p-5">
              <iframe
                width="100%" // Width is set to 100% to take up the available width
                height="315"
                src="https://www.youtube.com/embed/iwBYd1eKV4Y" // Replace with your video URL
                title="YouTube video demo"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default CampaignReports;
